import React from 'react';

import styled from 'styled-components';

import Button from '../../../components/lib/Button';

const Container = styled.div`
  display: flex;
  justify-content: end;
  gap: 10px;
  padding: 20px;
  border-top: 1px solid var(--line-gray);
`;

interface Props {
  onNext: () => void;
  onClose: () => void;
}
const SnapshotEditorModalActions = ({ onClose, onNext }: Props) => (
  <Container>
    <Button style={{ height: 40, width: 120 }} type={'primary'} onClick={onNext}>
      Next
    </Button>
    <Button style={{ height: 40, width: 120 }} onClick={onClose}>
      Cancel
    </Button>
  </Container>
);

export default SnapshotEditorModalActions;
